import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import styles from './styles/CreatorsLetterSelector.scss';

function CreatorsLetterSelectorComponent({ creatorGroups, onLetterSelect }) {
    const list = creatorGroups.map(({ groupName }, i) => {
        const id = groupName.toLowerCase();
        return (
            <Fragment key={groupName}>
                {i !== 0 && <span className={styles.divider}> / </span>}
                <a className={styles.letter} href={`#${id}`} onClick={() => onLetterSelect(id)}>
                    {groupName}
                </a>
            </Fragment>
        );
    });
    return (
        <div className={styles.wrapper} data-tn="letter-selector">
            {list}
        </div>
    );
}

CreatorsLetterSelectorComponent.propTypes = {
    creatorGroups: PropTypes.array.isRequired,
    onLetterSelect: PropTypes.func.isRequired,
};

export const CreatorsLetterSelector = createFragmentContainer(CreatorsLetterSelectorComponent, {
    creatorGroups: graphql`
        fragment CreatorsLetterSelector_creatorGroups on CreatorGroup @relay(plural: true) {
            groupName
        }
    `,
});
